// extracted by mini-css-extract-plugin
export default {"summary":"BeneficiariesInformations_summary__7VUOn","iconsContainer":"BeneficiariesInformations_iconsContainer__VV0yJ"};